import React from 'react';
import { Link } from 'react-router-dom';
import AdminNavbar from '../components/AdminNavbar';

const AdminDashboard = () => {

  const links = [
    { 
      name: 'Home Page',
      path: '/admin-dashboard/home-page',
      icon: (
        <svg className="h-12 w-12 text-blue-800 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
            d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" 
          />
        </svg>
      )
    },
    { 
      name: 'Events', 
      path: '/admin-dashboard/events',
      icon: (
        <svg className="h-12 w-12 text-blue-800 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" 
          />
        </svg>
      )
    },
    {
      name: 'Centers',
      path: '/admin-dashboard/centers',
      icon: (
        <svg className="h-12 w-12 text-blue-800 mb-4" viewBox="0 0 24 24" fill="currentColor">
          <path
            fillRule="evenodd"
            d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
            clipRule="evenodd"
          />
        </svg>
      )
    },
    {
      name: 'Forms',
      path: '/admin-dashboard/forms',
      icon: (
        <svg className="h-12 w-12 text-blue-800 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
          />
        </svg>
      )
    },
    // { 
    //   name: 'Jobs', 
    //   path: '/admin-dashboard/jobs',
    //   icon: (
    //     <svg className="h-12 w-12 text-blue-800 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
    //         d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" 
    //       />
    //     </svg>
    //   )
    // },
    // { 
    //   name: 'Learning Material', 
    //   path: '/admin-dashboard/learning-material',
    //   icon: (
    //     <svg className="h-12 w-12 text-blue-800 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
    //         d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" 
    //       />
    //     </svg>
    //   )
    // },
  ];

  return (
    <div className="bg-gray-100 min-h-screen">

    <AdminNavbar/>      

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h2 className="text-2xl font-bold mb-6 text-blue-800">Admin Links</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {links.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="bg-white rounded-lg shadow-md hover:shadow-lg transform transition-all duration-300 hover:scale-105 active:scale-95"
            >
              <div className="p-6 flex flex-col items-center justify-center h-full">
                {link.icon}
                <h3 className="text-xl font-medium text-gray-800">{link.name}</h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
